import _ from 'lodash';
import Quill, { Delta } from 'quill/core';
import CodeEmbed from '../formats/CodeEmbed';

const insertCodeEmbed = ({
  quill,
  index,
  language,
  embedDelta,
}: {
  quill: Quill;
  index: number;
  language: string;
  embedDelta: Delta;
}) => {
  const delta = new Delta()
    .retain(index)
    .insert({ 'code-embed': embedDelta.ops }, { language });
  quill.updateContents(delta, Quill.sources.USER);

  const [codeEmbed] = quill.getLine(index);

  _.defer(() => {
    if (codeEmbed instanceof CodeEmbed) {
      // exclude the trailing \n
      codeEmbed.setSelection(0, embedDelta.length() - 1, Quill.sources.USER);
    }
  });
};

export default insertCodeEmbed;
